module.exports = __webpack_public_path__ + "img/logo.f4b627ea.jpg";